import { ITicker } from '@kattana-io/common';
import Text from '../../atoms/Text';
import { toFixed2 } from '../DexTrades/formatters';
import usePriceChange from '../Info/usePriceChange';
import { ICurrentState } from '../../reducers/current';

export const getPriceChangeArgs = (ticker: ITicker | ICurrentState) => {
  if (ticker.address) {
    return {
      chain: ticker.chain,
      address: ticker.address,
    };
  }

  const [base, quote] = ticker.name.split('/');
  return {
    chain: ticker.exchange,
    address: `${base}-${quote}`,
  };
};

interface IDailyPriceChange {
  ticker: ITicker;
  price: string;
}

const DailyPriceChange = (props: IDailyPriceChange) => {
  const { address, chain } = getPriceChangeArgs(props.ticker);

  const { priceChange, priceChangePercent } = usePriceChange(
    Number(props.price.slice(1)),
    props.ticker.flipped,
    chain,
    address
  );

  // Return nothing if price didn't changed
  if (priceChange === 0 || priceChangePercent === 0) {
    return (
      <div className='row'>
        <Text className='watchlist_row__name  watchlist_row--neutral' size={10}>
          (0%) $0
        </Text>
      </div>
    );
  }

  return (
    <div className='row'>
      <Text
        className={`watchlist_row__name  watchlist_row--${
          priceChangePercent < 0 ? 'red' : 'green'
        }`}
        size={10}
      >
        ({toFixed2(priceChangePercent)}%) ${toFixed2(priceChange)}
      </Text>
    </div>
  );
};

export default DailyPriceChange;
